import api from "./api.service";

export interface ExpenseCategory {
  id: string;
  name: string;
}

class ExpenseCategoriesService {
  async getExpenseCategories(): Promise<ExpenseCategory[]> {
    const response = await api.get("/expense-categories");
    return response.data;
  }

  async getExpenseCategoryById(id: string): Promise<ExpenseCategory> {
    const response = await api.get(`/expense-categories/${id}`);
    return response.data;
  }
}

export const expenseCategoriesService = new ExpenseCategoriesService();
